import '@angular/compiler';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { LayoutAuthoringComponent } from './layout.authoring/layout.authoring.component';
import { PageDatasetsComponent } from './page.datasets/page.datasets.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { ComponentDatasetInstructionsComponent } from './component.dataset.instructions/component.dataset.instructions.component';
import { PageDpoComponent } from './page.dpo/page.dpo.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageKnowledge_mapComponent } from './page.knowledge_map/page.knowledge_map.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentWorkspaceNavComponent } from './component.workspace.nav/component.workspace.nav.component';
import { PageSourcesComponent } from './page.sources/page.sources.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageKnowledge_graphComponent } from './page.knowledge_graph/page.knowledge_graph.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { ComponentAdminDpoComponent } from './component.admin.dpo/component.admin.dpo.component';
import { ComponentSourceUploadComponent } from './component.source.upload/component.source.upload.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorkspaceResolver } from './workspace-resolver';
import { deferredWorkspacePages, loadWorkspacePage } from './workspace-pages';
import { URLPattern } from 'urlpattern-polyfill';

let appRoutes: Routes = [
    {
        component: LayoutAuthoringComponent,
        "children": [
            {
                "path": "datasets",
                component: PageDatasetsComponent,
                "app_id": "page.datasets"
            },
            {
                "path": "dpo",
                component: PageDpoComponent,
                "app_id": "page.dpo"
            },
            {
                "path": "access/:mode?",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "knowledge-map",
                component: PageKnowledge_mapComponent,
                "app_id": "page.knowledge_map"
            },
            {
                "path": "sources",
                component: PageSourcesComponent,
                "app_id": "page.sources"
            },
            {
                "path": "",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "knowledge-graph",
                component: PageKnowledge_graphComponent,
                "app_id": "page.knowledge_graph"
            },
            {
                "path": "admin",
                component: PageAdminComponent,
                "app_id": "page.admin"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = '';
    public segment: any = {};
}

window.WizRoute = new RouteInfo();

const patternMatcher = (pattern: any, url: any) => {
    const urlPath = url.map((item: any) => item.path).join('/');
    const testUrl = 'http://test/';
    const urlPattern = new URLPattern({ pathname: '/' + pattern });
    const match = urlPattern.exec(testUrl + urlPath);

    if (!match || !match.pathname) return null;

    const posParams = {};
    for (const key in match.pathname.groups) {
        if (match.pathname.groups[key]) {
            posParams[key] = match.pathname.groups[key];
        }
    }

    window.WizRoute.path = urlPath;
    window.WizRoute.segment = posParams;
    return { consumed: url, posParams };
};

const routes: Routes = [];

for (const layout of appRoutes) {
    const router: any = {
        path: '',
        component: layout.component,
        children: []
    };

    for (const child of layout.children) {
        const pageRoute: any = {
            matcher: (url: any) => patternMatcher(child.path, url),
            component: child.component,
            ...(['sources', 'datasets', 'knowledge-graph', 'admin'].includes(child.path) ? {canDeactivate: [(component:any) => component.canDeactivate()]} : {}),
            ...(['sources', 'datasets', 'knowledge-graph'].includes(child.path) ? {runGuardsAndResolvers: 'paramsOrQueryParamsChange'} : {}),
            ...(['', 'sources', 'datasets', 'knowledge-graph', 'knowledge-map', 'dpo', 'admin'].includes(child.path) ? {
                data: {workspacePage: child.path === 'admin' ? 'admin' : child.path === 'datasets' ? 'datasets' : child.path === 'sources' ? 'sources' : child.path === 'knowledge-graph' ? 'knowledge' : child.path === 'knowledge-map' ? 'map' : child.path === 'dpo' ? 'dpo' : 'dashboard'},
                resolve: {workspace: WorkspaceResolver}
            } : {})
        };
        if (deferredWorkspacePages.has(child.app_id)) {
            const {matcher, ...featureRoute} = pageRoute;
            router.children.push({
                matcher,
                loadChildren: () => loadWorkspacePage(child.app_id, {path: '', ...featureRoute})
            });
        } else {
            router.children.push(pageRoute);
        }
    }

    routes.push(router);
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
